import moment from 'moment';

// Date format constant for driver appeals - includes year, time with AM/PM, and timezone
export const DRIVER_APPEALS_DATETIME_FORMAT = 'YYYY-MM-DD hh:mm A z';

export const addTypeDate = (events) => {
  if (!events || events.length < 1) return [];
  let date = '1/1/1970';
  let timelined = [];
  events.forEach((e) => {
    const day = moment(e.ts).startOf('day').format('M/D/YYYY');
    if (day !== date) {
      timelined.push({
        type: 'DATE',
        ts: day,
      });
    }
    date = day;
    timelined.push(e);
  });
  return timelined;
};

export const isGreaterThanOneYear = (start, end) => {
  if (!start || !end) return;
  if (moment.duration(moment(end).diff(moment(start))).asYears() > 1) {
    return true;
  }
  return false;
};

export const isAfterDay = (start, end) => {
  if (!start || !end) return;
  return moment(start).isAfter(end);
};
